import { parseCurrencyString } from "@/utils/parseCurrencyString";
import * as yup from "yup";

export const expenseSchema = yup.object({
  description: yup.string().when("$isWriteOff", {
    is: false,
    then: (schema) => schema.required("Descrição é obrigatória"),
    otherwise: (schema) => schema.notRequired(),
  }),
  payment_method_id: yup.string().required("Forma de pagamento obrigatória"),
  supplier_id: yup.string().nullable().notRequired(),
  amount: yup
    .string()
    .transform(parseCurrencyString)
    .test(
      "is-required",
      "Valor é obrigatório",
      (value) => !!value && value !== "0" && value !== "0.00",
    )
    .test("is-valid", "Valor deve ser maior que zero", (value) => {
      const numberValue = parseFloat(value ?? "0");
      return !isNaN(numberValue) && numberValue > 0;
    }),
  expiry_date: yup
    .string()
    .transform((value) => (value ? value.trim() : null))
    .when("$isWriteOff", {
      is: false,

      otherwise: (schema) => schema.notRequired(),
    }),
  paid_at: yup.string().nullable().notRequired(),
});
